(function () {
  if (!window.location.pathname.includes('/collections/')) return;

  var faqs = [];
  var currentQuestion = null;
  var currentAnswer = [];

  var allH2 = Array.from(document.querySelectorAll('h2'));
  var faqH2 = allH2.find(function (h) {
    return /faq|frequently asked/i.test(h.textContent);
  });

  if (!faqH2) return;

  var el = faqH2.nextElementSibling;
  while (el && el.tagName !== 'H2') {
    if (el.tagName === 'H3') {
      if (currentQuestion && currentAnswer.length) {
        faqs.push({ q: currentQuestion, a: currentAnswer.join(' ') });
      }
      currentQuestion = el.textContent.trim();
      currentAnswer = [];
    } else if ((el.tagName === 'P' || el.tagName === 'LI') && currentQuestion) {
      var text = el.textContent.trim();
      if (text) currentAnswer.push(text);
    }
    el = el.nextElementSibling;
  }

  if (currentQuestion && currentAnswer.length) {
    faqs.push({ q: currentQuestion, a: currentAnswer.join(' ') });
  }

  if (!faqs.length) return;

  var schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(function (faq) {
      return {
        "@type": "Question",
        "name": faq.q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.a
        }
      };
    })
  };

  var script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
})();